export enum nameSortOption {
  AtoZ = 'A-Z',
  ZtoA = 'Z-A',
}
